import { Button, CircularProgress } from '@mui/material'
import { CustomTableData } from 'common'
import { TooltipInformation } from 'common'
import TooltipAprobacion from 'common/TooltipAprobacion/TooltipAprobacion'
import { Edit3, Trash2 } from 'react-feather'


const PreInventoryTable = ({useFetchInit}) => {

    const {
        globalStates,
        FetchData,
        Actions,
        Forms
    }= useFetchInit


    const { fetchAllPreInventory:{preInventory} } = FetchData

    // const {handleClickDeleteDeposit, handleClickFetchInfoDeposit} = Actions
    const { modalOpeningMode, formOpeningMode } = globalStates

    const {FormRequestGlobal:{formState}} = Forms

    const {handleClickFetchInfoPreInventory, handleClickDeletePreInventory, pending} = Actions


  
    const columnConfig = [
        { 
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                    //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                    const {idvehicledeposit, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                    return(
                        <>
                            <TooltipInformation 
                                idregistro={idvehicledeposit}
                                usuario_creo={usuario_creo}
                                fecha_creo={fecha_creo}
                                usuario_modifico={usuario_modifico}
                                fecha_modifico={fecha_modifico}
                            />
                        </>
                        
                    )
            }
        },
        { 
            field: "marca",
            headerName: "MARCA",
            minWidth: 130,
            maxWidth: 130,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
        },
        { field: "matricula", headerName: "MATRICULA", minWidth: 220, filter: true },
        { field: "modelo", headerName: "MODELO", minWidth: 130, filter: true },
        { field: "linea", headerName: "LINEA", minWidth: 180, filter: true },
        { field: "color", headerName: "COLOR", minWidth: 130, filter: true },
        { field: "valor", headerName: "VALOR (Q)", minWidth: 130, filter: true },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const {idvehicledeposit} = params.data
                               
                if ((formState.aprobacion_check === 'Pendiente Contrato') && (formOpeningMode==='EDITABLE')){
                     return(
                        <>
                            <Button 
                                startIcon = { <Edit3/>}
                                variant='contained'
                                size='small' 
                                color='success'
                                sx={{ marginRight: '8px' }}
                                onClick={() => handleClickFetchInfoPreInventory(idvehicledeposit, 'EDITABLE')} 
                                style={ { width: 150 } }
                                > 
                                Editar
                            </Button>
                            
                            <Button
                                variant='contained'
                                size='small'
                                onClick={()=>handleClickDeletePreInventory(idvehicledeposit)}
                                color='error'
                                style={ { marginRight: '0.4vh' } }
                                disabled={pending.deletePreInventory}
                            >
                                {pending.deletePreInventory
                                    ? <CircularProgress size={14} color="inherit" style={{ marginRight: '8px' }} />
                                    : <i className="fa-solid fa-trash" style={{ marginRight: '8px' }}></i>
                                }
                                Eliminar
                            </Button>
                        </>
                    )
                }else{
                    return(
                        <>
                            <Button 
                                variant='contained' 
                                size='small' 
                                onClick={()=>handleClickFetchInfoPreInventory(idvehicledeposit, 'READONLY')} 
                                color='info' 
                                style={ { marginRight: '0.4vh' } }  > 
                                <i className="fa-solid fa-info-circle" style={{ marginRight: '8px' }}></i> Ver Detalles
                            </Button>
                        </>
                    )
                }
                
            }
        },
    ]

    return (
        <div className='content'>
            <CustomTableData 
                rowConfig={preInventory}
                columnConfig={columnConfig}
            />
        </div>
    )
}

export{
    PreInventoryTable
}